import { Route, UrlMatcher, UrlMatchResult, UrlSegment, UrlSegmentGroup } from '@angular/router';
import { AppPathParams } from '@libs/shared-services';

/**
 * A matcher that checks if the path matches any item in a given array. If it does, we consume the relevant parts of the URL. If it isn't, we return null.
 * @param paths the array of paths to be matched
 * @param pathParam the path parameter to be matched and be passed forward as a pathParameter to be accessed in components
 * @returns the consumed URL if it exists within the given `paths`, or null if it isn't
 */

export const dynamicRouteMatcher = (paths: string[], pathParam?: keyof AppPathParams): UrlMatcher => {
  const pathsSet = new Set<string>(paths);
  return (url: UrlSegment[], group: UrlSegmentGroup, route: Route): UrlMatchResult | null => {
    const impliedParams = paths.flatMap((path) => path.split('/').filter((segment) => segment.startsWith(':')));
    // If the URL has only one segment, we consume it if it exists within paths. If not, we return null
    if (url.length === 1) {
      const consumedUrlObject: UrlMatchResult = {
        consumed: url,
      };

      if (pathParam) {
        consumedUrlObject.posParams = {
          [pathParam]: url[0],
        };
      }

      return pathsSet.has(url[0]?.path) ? consumedUrlObject : null;
    }
    const consumedUrlObject: UrlMatchResult = {
      consumed: url.slice(0, 1),
    };

    if (pathParam) {
      consumedUrlObject.posParams = {
        [pathParam]: url[0],
      };
    }

    // If the URL has more than one segment, we consume the first segment if it exists within paths. If not, we return null
    return pathsSet.has(url[0]?.path) ? consumedUrlObject : null;
  };
};
